"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.REMAINING_BUDGET_LABEL = exports.COMPONENT_IDENTIFIER = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _card = require("../../../../../card");
var _input = require("../../../../../input");
var _collapse = require("../../../../../collapse");
var _CustomLabel = _interopRequireDefault(require("./CustomLabel.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var COMPONENT_IDENTIFIER = 'budgetLabel';
exports.COMPONENT_IDENTIFIER = COMPONENT_IDENTIFIER;
var REMAINING_BUDGET_LABEL = 'remainingBudgetLabel';
exports.REMAINING_BUDGET_LABEL = REMAINING_BUDGET_LABEL;
var CUSTOM_TITLE_MAX_LENGTH = 30;
var CustomLabel = function CustomLabel(props) {
  var errors = props.errors,
    labels = props.labels,
    rule = props.rule,
    ruleChange = props.ruleChange,
    disabled = props.disabled;
  var customLabel = R.prop(COMPONENT_IDENTIFIER, rule);
  var remainingBudgetLabel = R.prop(REMAINING_BUDGET_LABEL, rule);
  var hasCustomLabel = !R.isNil(customLabel);
  return /*#__PURE__*/_react["default"].createElement(_collapse.Collapse, {
    openItems: hasCustomLabel ? [0] : []
  }, function (_ref) {
    var toggle = _ref.toggle,
      openItems = _ref.openItems;
    return /*#__PURE__*/_react["default"].createElement(_CustomLabel["default"], {
      isOpen: openItems.includes(0)
    }, /*#__PURE__*/_react["default"].createElement(_card.ControlCard, {
      id: "custom-label-card",
      className: "custom-label-card",
      title: /*#__PURE__*/_react["default"].createElement("div", {
        className: "custom-label-header"
      }, /*#__PURE__*/_react["default"].createElement("span", null, labels.REMAINING_BUDGET_CUSTOM_LABEL_TITLE)),
      checked: hasCustomLabel,
      onChange: function onChange(_, checked) {
        ruleChange(COMPONENT_IDENTIFIER, checked ? '' : null, REMAINING_BUDGET_LABEL);
        toggle(0);
      },
      disabled: disabled
    }, /*#__PURE__*/_react["default"].createElement(_input.Input, {
      type: "text",
      placeholder: labels.BUDGET_LABEL,
      errors: errors[COMPONENT_IDENTIFIER],
      id: "budgetCustomLabelInput",
      value: customLabel,
      maxLength: CUSTOM_TITLE_MAX_LENGTH,
      onChange: function onChange(event) {
        ruleChange(COMPONENT_IDENTIFIER, event.target.value);
      },
      disabled: disabled
    }), /*#__PURE__*/_react["default"].createElement(_input.Input, {
      type: "text",
      placeholder: labels.REMAINING_BUDGET,
      errors: errors[REMAINING_BUDGET_LABEL],
      id: "remainingBudgetCustomLabelInput",
      value: remainingBudgetLabel,
      maxLength: CUSTOM_TITLE_MAX_LENGTH,
      onChange: function onChange(event) {
        ruleChange(REMAINING_BUDGET_LABEL, event.target.value);
      },
      disabled: disabled
    }), /*#__PURE__*/_react["default"].createElement("p", {
      className: "custom-label-info"
    }, labels.REMAINING_BUDGET_HELPER_TEXT)));
  });
};
CustomLabel.defaultProps = {
  errors: {},
  disabled: false
};
CustomLabel.propTypes = {
  rule: _propTypes["default"].shape({}).isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  errors: _propTypes["default"].shape({}),
  disabled: _propTypes["default"].bool
};
CustomLabel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "CustomLabel",
  "props": {
    "errors": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "rule": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    },
    "ruleChange": {
      "description": "",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "labels": {
      "description": "",
      "type": {
        "name": "objectOf",
        "value": {
          "name": "string"
        }
      },
      "required": true
    }
  }
};
var _default = /*#__PURE__*/(0, _react.memo)(CustomLabel);
exports["default"] = _default;